<template>
  <path
    d="M12 2.00018C8.13 2.00018 5 5.13018 5 9.00018C5 13.1702 9.42 18.9202 11.24 21.1102C11.64 21.5902 12.37 21.5902 12.77 21.1102C14.58 18.9202 19 13.1702 19 9.00018C19 5.13018 15.87 2.00018 12 2.00018ZM12 11.5002C10.62 11.5002 9.5 10.3802 9.5 9.00018C9.5 7.62018 10.62 6.50018 12 6.50018C13.38 6.50018 14.5 7.62018 14.5 9.00018C14.5 10.3802 13.38 11.5002 12 11.5002Z"
  />
</template>
